import React from "react";
import LegalLayout from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout
      title="Cookies"
      path="/cookies"
      description="Cookies notice for the Culmora OS pre-launch website."
    >
      <p>
        This website uses only essential technical browser storage required for
        security and form operation.
      </p>
      <h2>Essential technical storage</h2>
      <p>
        A session identifier is kept in your browser's session storage so the
        request form can apply security and anti-abuse rate limits. It contains
        no personal information and is removed when the browser session ends.
      </p>
      <h2>Bot protection</h2>
      <p>
        If enabled, Cloudflare Turnstile protects the request form from
        automated abuse. As part of that verification, Cloudflare may set or
        read challenge data in your browser. This is strictly for security.
      </p>
      <h2>Analytics cookies</h2>
      <p>No analytics cookies are active.</p>
      <h2>Marketing cookies</h2>
      <p>No marketing cookies are active.</p>
      <h2>Advertising cookies</h2>
      <p>No advertising cookies are active.</p>
      <h2>Updates</h2>
      <p>
        This notice will be updated before any non-essential cookies or storage
        are introduced.
      </p>
    </LegalLayout>
  );
}
